export const RETAIL_LAUNCHPAD = 'Retail Launchpad'

export const OKTA = 'okta';
export const RETAIL = 'retail';

export const TRUE_RETAIL_AUTH = 'trueRetailAuth';
export const TRUE_AUTH_SOURCE = 'trueAuthSource';
export const OKTA_CACHE_STORAGE = 'okta-cache-storage';
export const OKTA_TOKEN_STORAGE = 'okta-token-storage';
export const OKTA_OAUTH_REDIRECT_PARAMS = 'okta-oauth-redirect-params';
export const OKTA_PKCE_STORAGE = 'okta-pkce-storage';

export const REQUEST_ACCESS_TOKEN = 'requestAccessToken';
export const SET_TITLE = 'setTitle';
export const LOGOUT = 'logout';
export const CLOSE = 'close';
export const GET_LANGUAGE = 'getLanguage';
export const GET_URL = 'getUrl'
export const ADDRESS_BAR = 'addressbar';
export const SEND_STORE = 'sendStore'

export const LOGIN = 'login';
export const ACCESS_TOKEN = 'accessToken';
export const LOADING = 'loading';
